<template>
  <div class="body1">
    <div class="content">
      <div class="title">Our Presence</div>
      <img class="img" src="../../assets/swipper-3.png">
    </div>
  </div>
</template>

<script>
import {SwiperSlide} from "vue-awesome-swiper";

export default {
  components: {SwiperSlide},
  data() {
    return {}
  },
  mounted() {
  },
  methods: {}
}
</script>

<style scoped lang="less">
@import "../../assets/style/index";

.body1{
  height: 626px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  background: url("../../assets/body4-bg.png") no-repeat;
  background-size: auto 100%;
  position: relative;
  .content{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    justify-content: center;
    .title{
      color: #674789;
      font-size: 38px;
      font-family: 'Adobe Heiti Std', Helvetica, Arial, sans-serif;
      line-height: 50px;
      position: absolute;
      top: 80px;
    }

    .img{
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}


</style>


// WEBPACK FOOTER //
// src/components/index/e-body4.vue